module.exports = "/images/dropdown.svg?9f6969648e4a70de526956a78406b282";